import { createTheme } from '@mui/material/styles';

// Paleta de colores general para todos los componentes del proyecto
// Enfoque: Estilo "Antigravity Blanquita" (Minimalista, Fondo Blanco, Alto Contraste)

export const paletaColores = {
  // Colores oficiales del Manual de Marca Hitpoly (ahora usados estrictamente como acentos sutiles)
  primary: {
    purple: {
      light: '#6C4DE2',
      main: '#3B207F',
      dark: '#2D1638',
      contrastText: '#ffffff'
    },
    blue: {
      light: '#00C2FF',
      main: '#0B8DB5',
      dark: '#08779A',
      contrastText: '#ffffff'
    },
    pink: {
      light: '#EF50BA',
      main: '#F21C63',
      dark: '#C01750',
      contrastText: '#ffffff'
    },
    // Colores primarios por defecto (para compatibilidad con primary.main)
    main: '#0B8DB5',
    light: '#00C2FF',
    dark: '#08779A'
  },
  // Color secundario por defecto (para compatibilidad con secondary.main)
  secondary: {
    main: '#F3F4F6',
    light: '#FAFAFA',
    dark: '#E5E7EB',
    contrastText: '#111111'
  },

  // Colores por Tipo de Componente
  components: {
    buttons: {
      // Estilo p	ldora oscuro (Antigravity)
      primary: {
        background: '#111111',
        hover: '#262626',
        active: '#000000',
        text: '#ffffff',
        border: '1px solid #111111'
      },
      // Estilo fantasma (Antigravity explore use cases)
      secondary: {
        background: '#F9FAFB',
        hover: '#F3F4F6',
        active: '#E5E7EB',
        text: '#111111',
        border: '1px solid #E5E7EB'
      },
      accent: {
        background: '#F21C63',
        hover: '#D91859',
        active: '#B5144A',
        text: '#ffffff',
        border: '1px solid #F21C63'
      },
      danger: {
        background: '#EF4444',
        hover: '#DC2626',
        active: '#B91C1C',
        text: '#ffffff',
        border: '1px solid #EF4444'
      },
      success: {
        background: '#10B981',
        hover: '#059669',
        active: '#047857',
        text: '#ffffff',
        border: '1px solid #10B981'
      },
      warning: {
        background: '#F59E0B',
        hover: '#D97706',
        active: '#B45309',
        text: '#ffffff',
        border: '1px solid #F59E0B'
      },
      info: {
        background: '#3B82F6',
        hover: '#2563EB',
        active: '#1D4ED8',
        text: '#ffffff',
        border: '1px solid #3B82F6'
      },
      ghost: {
        background: 'transparent',
        hover: '#F3F4F6',
        active: '#E5E7EB',
        text: '#111111',
        border: '1px solid transparent'
      }
    },

    containers: {
      // Jerarquía de componentes en el modo lienzo blanco
      parent: {
        background: '#FFFFFF',
        border: '#E5E7EB',
        shadow: 'none',
        backdrop: 'none'
      },
      child: {
        background: '#FFFFFF',
        border: '#F3F4F6',
        shadow: 'none',
        backdrop: 'none'
      },
      grandchild: {
        background: '#F9FAFB',
        border: '#F3F4F6',
        shadow: 'none',
        backdrop: 'none'
      },
      greatgrandchild: {
        background: '#F3F4F6',
        border: '#E5E7EB',
        shadow: 'none',
        backdrop: 'none'
      }
    },

    forms: {
      input: {
        background: '#FFFFFF',
        border: '#E5E7EB',
        focus: '#111111',
        placeholder: '#9CA3AF'
      },
      label: {
        color: '#111111',
        required: '#EF4444'
      },
      error: {
        background: '#FEF2F2',
        border: '1px solid #FECACA',
        text: '#EF4444'
      },
      success: {
        background: '#ECFDF5',
        border: '1px solid #A7F3D0',
        text: '#10B981'
      },
      warning: {
        background: '#FFFBEB',
        border: '1px solid #FDE68A',
        text: '#F59E0B'
      }
    },

    banners: {
      // Minimalistas o de un color muy sutil, en su mayor	a blancos
      primary: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
      secondary: 'linear-gradient(180deg, #FAFAFA 0%, #F3F4F6 100%)',
      accent: 'linear-gradient(135deg, rgba(242, 28, 99, 0.05) 0%, rgba(239, 80, 186, 0.05) 100%)',
      danger: '#FEF2F2',
      success: '#ECFDF5',
      warning: '#FFFBEB',
      info: '#EFF6FF',
      asignaciones: '#FFFFFF'
    },

    alerts: {
      success: {
        background: '#ECFDF5',
        border: '1px solid #A7F3D0',
        text: '#047857',
        icon: '#10B981'
      },
      error: {
        background: '#FEF2F2',
        border: '1px solid #FECACA',
        text: '#B91C1C',
        icon: '#EF4444'
      },
      warning: {
        background: '#FFFBEB',
        border: '1px solid #FDE68A',
        text: '#B45309',
        icon: '#F59E0B'
      },
      info: {
        background: '#EFF6FF',
        border: '1px solid #BFDBFE',
        text: '#1D4ED8',
        icon: '#3B82F6'
      },
      neutral: {
        background: '#F9FAFB',
        border: '1px solid #E5E7EB',
        text: '#374151',
        icon: '#9CA3AF'
      }
    }
  },

  // Colores de Texto (Alto contraste, muy oscuros)
  text: {
    primary: '#0A0A0A',
    secondary: '#525252',
    tertiary: '#A3A3A3',
    muted: '#A3A3A3',
    disabled: '#D4D4D4',
    inverse: '#ffffff'
  },

  // Colores de estado (success, danger, warning, info)
  success: {
    light: '#34D399',
    main: '#10B981',
    dark: '#059669',
    contrastText: '#ffffff'
  },

  danger: {
    light: '#F87171',
    main: '#EF4444',
    dark: '#DC2626',
    contrastText: '#ffffff'
  },

  warning: {
    light: '#FBBF24',
    main: '#F59E0B',
    dark: '#D97706',
    contrastText: '#ffffff'
  },

  info: {
    light: '#60A5FA',
    main: '#3B82F6',
    dark: '#2563EB',
    contrastText: '#ffffff'
  },

  // Colores de Fondo General (Canvas totalmente blanco)
  backgrounds: {
    primary: '#FFFFFF',
    secondary: '#FFFFFF',
    tertiary: '#FAFAFA',
    quaternary: '#F3F4F6',
    dark: '#111111',
    paper: '#FFFFFF'
  },

  // Colores de Borde (Líneas finas)
  borders: {
    soft: '#F3F4F6',
    medium: '#E5E7EB',
    hard: '#D1D5DB',
    danger: '#EF4444',
    success: '#10B981',
    warning: '#F59E0B',
    info: '#3B82F6',
    black: '#111111'
  },

  shadows: {
    soft: '0 1px 2px rgba(0, 0, 0, 0.04)',
    medium: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
    hard: '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04)',
    subtle: '0 1px 3px rgba(0,0,0,0.02)',
    deep: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  },

  states: {
    hover: {
      primary: 'rgba(0, 0, 0, 0.04)',
      secondary: 'rgba(0, 0, 0, 0.02)',
      accent: 'rgba(242, 28, 99, 0.04)'
    },
    active: {
      primary: 'rgba(0, 0, 0, 0.08)',
      secondary: 'rgba(0, 0, 0, 0.06)',
      accent: 'rgba(242, 28, 99, 0.08)'
    },
    focus: {
      primary: '0 0 0 2px #FFFFFF, 0 0 0 4px #111111',
      secondary: '0 0 0 2px #FFFFFF, 0 0 0 4px #E5E7EB',
      accent: '0 0 0 2px #FFFFFF, 0 0 0 4px #F21C63'
    },
    disabled: {
      background: '#F3F4F6',
      text: '#9CA3AF',
      border: '1px solid #E5E7EB'
    }
  },

  glows: {
    primary: 'none',
    secondary: 'none',
    accent: 'none',
    success: 'none',
    danger: 'none',
    warning: 'none',
    info: 'none'
  }
};


// Funciones Utilitarias para Colores
export const getColorByType = (componentType) => {
  switch (componentType.toLowerCase()) {
    case 'button': return paletaColores.components.buttons.primary;
    case 'container': return paletaColores.components.containers.parent;
    case 'form': return paletaColores.components.forms.input;
    case 'banner': return paletaColores.components.banners.primary;
    case 'alert': return paletaColores.components.alerts.success;
    default: return paletaColores.components.buttons.primary;
  }
};

export const getColorByHierarchy = (level) => {
  switch (level.toLowerCase()) {
    case 'parent': return paletaColores.components.containers.parent;
    case 'child': return paletaColores.components.containers.child;
    case 'grandchild': return paletaColores.components.containers.grandchild;
    case 'greatgrandchild': return paletaColores.components.containers.greatgrandchild;
    default: return paletaColores.components.containers.parent;
  }
};

export const getColorByState = (state) => {
  switch (state.toLowerCase()) {
    case 'hover': return paletaColores.states.hover.primary;
    case 'active': return paletaColores.states.active.primary;
    case 'focus': return paletaColores.states.focus.primary;
    case 'disabled': return paletaColores.states.disabled;
    default: return paletaColores.states.hover.primary;
  }
};

export const getGradientByType = (type) => paletaColores.components.banners[type] || paletaColores.components.banners.primary;
export const getAlertColor = (type) => paletaColores.components.alerts[type] || paletaColores.components.alerts.success;
export const getButtonColor = (type) => paletaColores.components.buttons[type] || paletaColores.components.buttons.primary;
export const getGlowColor = (type) => paletaColores.glows[type] || paletaColores.glows.primary;
export const getBackgroundColor = (type) => paletaColores.backgrounds[type] || paletaColores.backgrounds.primary;
export const getTextColor = (type) => paletaColores.text[type] || paletaColores.text.primary;
export const getBorderColor = (type) => paletaColores.borders[type] || paletaColores.borders.soft;
export const getShadowColor = (type) => paletaColores.shadows[type] || paletaColores.shadows.soft;


// Tema MUI basado en la paleta general - Estilo Antigravity
export const temaGeneral = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#111111',
      light: '#262626',
      dark: '#000000',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#F3F4F6',
      light: '#FAFAFA',
      dark: '#E5E7EB',
      contrastText: '#111111'
    },
    error: {
      main: '#EF4444',
      light: '#F87171',
      dark: '#DC2626',
      contrastText: '#ffffff'
    },
    success: {
      main: '#10B981',
      light: '#34D399',
      dark: '#059669',
      contrastText: '#ffffff'
    },
    background: {
      default: '#FFFFFF', // Lienzo 100% blanco
      paper: '#FFFFFF'
    },
    text: {
      primary: '#0A0A0A',
      secondary: '#525252'
    },
    divider: '#E5E7EB'
  },
  typography: {
    fontFamily: '"Inter", "Montserrat", "Helvetica Neue", sans-serif',
    h1: { fontWeight: 700, letterSpacing: '-0.02em', color: '#0A0A0A' },
    h2: { fontWeight: 600, letterSpacing: '-0.01em', color: '#0A0A0A' },
    h3: { fontWeight: 600, color: '#0A0A0A' },
    h4: { fontWeight: 600, color: '#0A0A0A' },
    h5: { fontWeight: 600, color: '#0A0A0A' },
    h6: { fontWeight: 600, color: '#0A0A0A' },
    subtitle1: { color: '#525252' },
    subtitle2: { color: '#525252', fontWeight: 500 },
    body1: { color: '#0A0A0A' },
    body2: { color: '#525252' },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      letterSpacing: '0.01em'
    }
  },
  shape: {
    borderRadius: 8, // Bordes menos curvos que antes
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#FFFFFF',
          margin: 0,
          padding: 0,
          caretColor: '#111111',
          '&::-webkit-scrollbar': {
            width: '6px',
            height: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#D1D5DB',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: '#FFFFFF',
          border: '1px solid #E5E7EB', // Borde fino en lugar de sombra fuerte
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.02)', // Sombra lev	sima
          transition: 'all 0.2s ease',
          '&:hover': {
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
            borderColor: '#D1D5DB'
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.02)',
          border: '1px solid #E5E7EB',
          backgroundImage: 'none' // Evita que MUI ponga overlays en elevaci	n
        },
        elevation1: { boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)' },
        elevation2: { boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' },
        elevation3: { boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)' },
        elevation4: { boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '100px', // Estilo píldora como el botón "Download"
          textTransform: 'none',
          boxShadow: 'none',
          padding: '8px 20px',
          fontWeight: 500,
          transition: 'all 0.2s ease',
          '&:hover': {
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transform: 'translateY(-1px)'
          }
        },
        containedPrimary: {
          backgroundColor: '#111111',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#262626',
          }
        },
        outlinedPrimary: {
          borderColor: '#E5E7EB',
          color: '#111111',
          backgroundColor: '#F9FAFB',
          '&:hover': {
            borderColor: '#D1D5DB',
            backgroundColor: '#F3F4F6'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: '#FFFFFF',
          transition: 'all 0.2s ease',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E5E7EB',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D1D5DB',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#111111',
            borderWidth: '1px'
          }
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#FFFFFF',
          borderRight: '1px solid #E5E7EB'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#0A0A0A',
          boxShadow: 'none',
          borderBottom: '1px solid #E5E7EB'
        }
      }
    }
  }
});

export default paletaColores;